import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main'
import PesertaUjian from '@/pages/PesertaUjian'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/main',
      name: 'main',
      component: Main,
      children: [
        { path: 'pesertaujian', name: 'pesertaujian', component: PesertaUjian, meta: {title: 'Daftar Peserta Ujain'} }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src_suopass/router/index.js